import React, { Component } from 'react';
import { Modal, Input, Tooltip, message } from "antd";
import { addCriticalCase } from "@/request/api";

const { TextArea } = Input;
class CriticalCaseInfo extends Component {
  state = {
    criticalInfo: ""
  }

  componentDidMount() {
    const { rowData } = this.props;
    this.setState({
      criticalInfo: rowData.DANGER_MSG || rowData.CONCLUSIONS
    })
  }
  changeTextArea = (e) => {
    this.setState({
      criticalInfo: e.target.value
    })
  }
  onSubmit = async () => {
    let params = {
      EXAM_UID: this.props.rowData.EXAM_UID,
      DANGER_MSG: this.state.criticalInfo,
      IS_TOP: 1, // 1置顶 0不置顶
    }
    let res = await addCriticalCase(params);
    if (res && res.Status === 1) {
      message.success("危急值添加成功！");
      this.props.onRef(false);
      this.props.refreshTable();
    } else {
      message.error("危急值添加失败！");
    }
  }

  onCancel = () => {
    this.props.onRef(false);
  }

  render() {
    const { visible, rowData } = this.props;
    return (
      <Modal
        className="consulationH"
        width={460}
        title="危急病例"
        visible={visible}
        onOk={this.onSubmit} // 右下角的提交按钮
        onCancel={this.onCancel} // 右上角的关闭按钮
      >
        <div className="consulationInfo">
          <div className="applyInfo">
            <Tooltip title={rowData.NAME}>姓名：{rowData.NAME}</Tooltip>
            <Tooltip title={rowData.SEX_NAME}>性别：{rowData.SEX_NAME}</Tooltip>
            <Tooltip title={rowData.AgeDisPlay}>年龄：{rowData.AgeDisPlay}</Tooltip>
          </div>
          <div style={{ marginLeft: 6, marginBottom: 20 }}>
            <Tooltip title={rowData.PATIENT_ID}>病历号：{rowData.PATIENT_ID}</Tooltip>
          </div>
          <div style={{ padding: "5px" }}>
            <span>危急值信息:</span>
            <TextArea
              rows={4}
              maxLength={500}
              style={{ width: "400px", marginTop: "5px" }}
              placeholder="请输入危急值信息"
              defaultValue={rowData.DANGER_MSG || rowData.CONCLUSIONS}
              onChange={this.changeTextArea}
            />
          </div>
        </div>
      </Modal>
    )
  }
}

export default CriticalCaseInfo;